"use strict";

exports.__esModule = true;
exports.GroupOpen = void 0;

var Term_1 = require("../Term");

exports.GroupOpen = new Term_1.Term('GroupOpen', 'GROUP:OPEN', '(');